var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_vm._v("\n  "+_vm._s(_vm.SeperatedNumber)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }